import * as React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router'
import type { FirebaseApp } from 'firebase/app'
import type { Firestore } from 'firebase/firestore'

import { Env } from '@workspace/foundation/env'

import { StandaloneRedirect } from './standalone/StandaloneRedirect'

const EmbedLayout = React.lazy(() => import(/* webpackChunkName: "embed" */ './embed/EmbedLayout'))
const BackofficeLayout = React.lazy(() => import(/* webpackChunkName: "backoffice" */ './backoffice/BackofficeLayout'))

interface Props {
  firebaseApp: FirebaseApp
  db: Firestore
}

export const App = ({ firebaseApp, db }: Props) => (
  <BrowserRouter>
    <Env.Provider value={{ firebaseApp, db }}>
      <React.Suspense fallback={<div />}>
        <Routes>
          <Route path="/embed/*" element={<EmbedLayout />} />
          <Route path="/backoffice/*" element={<BackofficeLayout />} />
          <Route path="*" element={<StandaloneRedirect />} />
        </Routes>
      </React.Suspense>
    </Env.Provider>
  </BrowserRouter>
)
